import { DISTRIBUTOR } from '../constants/distributor';

const domainParser = (subDomain: string) => {
  if (subDomain.includes('intro')) {
    return subDomain.split('intro')[0].replace(/-/g, '');
  } else if (subDomain.includes('client')) {
    return subDomain.split('client')[0].replace(/-/g, '');
  } else if (subDomain.includes('maps')) {
    return subDomain.split('maps')[0].replace(/-/g, '');
  } else {
    return '';
  }
};

const getDistributorBySubDomain = (dist: string) => {
  switch (dist) {
    case 'cathaymyrewards':
    case 'mochi':
      return DISTRIBUTOR.CATHAYMR;
    case 'cpcpay':
      return DISTRIBUTOR.CPCPAY;
    case 'citibankmarketplace':
      return DISTRIBUTOR.CITIMKT;
    case 'linebank':
      return DISTRIBUTOR.LINE_BANK;
    case 'autopartner':
      return DISTRIBUTOR.AUTO_PARTNER;
    case 'iknow99':
      return DISTRIBUTOR.IKNOW99;
    case 'npc':
      return DISTRIBUTOR.NPCPAY;
    case 'test':
      return DISTRIBUTOR.UAT;
    case 'richartlife':
      return DISTRIBUTOR.RICHART_LIFE;
    case 'enterprise':
      return DISTRIBUTOR.ENTERPRISE;
    default:
      return DISTRIBUTOR.MOCHIPAY;
  }
};

export const appDistributor = (url: string) => {
  const subDomain = url.split('.')[0];
  const dist = domainParser(subDomain);
  return getDistributorBySubDomain(dist);
};
